import { useEffect, useState } from "react";

import {
  APPAREL_GENDER_OPTIONS, APPAREL_GENDER_VALUE_MEN, APPAREL_SIZE_OPTIONS, APPAREL_TYPE_NAME_SHOE,
  MEN_SHOE_SIZE_OPTIONS, WOMEN_SHOE_SIZE_OPTIONS
} from "./ApparelFormGridConstants";

import useApparelTypeData from "../../../state/apparelType/UseApparelTypeData";

const useApparelFormGrid = (gridData, personId, competitionGenderTypeCode, onSubmitFormCallback, onIsDirtyChanged, onErrorCaught) => {
  const { apparelTypeState, getApparelTypes } = useApparelTypeData();
  const [initialFormGridState, setInitialFormGridState] = useState([]);
  const [formGridState, setFormGridState] = useState([]);
  const [isDirtyState, setIsDirtyState] = useState(false);
  const [errorState, setErrorState] = useState('');

  const onSubmitFormGrid = (event) => {
    try {
      event?.preventDefault();

      const apparelDetails = [];
      let errorMessage = '';

      for (const apparelFormObj of formGridState) {
        if (apparelFormObj.apparelSizeId > 0 && apparelFormObj.apparelGenderId > 0) {
          const existingApparelValue = gridData.find((x) => x.nationalTeamApparelId === apparelFormObj.id);
          const apparelGenderValue = APPAREL_GENDER_OPTIONS.find((x) => x.id === apparelFormObj.apparelGenderId)?.value || '';
          const apparelSizeValue = apparelFormObj.name.includes(APPAREL_TYPE_NAME_SHOE) === false
            ? APPAREL_SIZE_OPTIONS.find((x) => x.id === apparelFormObj.apparelSizeId)?.value || ''
            : apparelGenderValue === APPAREL_GENDER_VALUE_MEN
              ? MEN_SHOE_SIZE_OPTIONS.find((x) => x.id === apparelFormObj.apparelSizeId)?.value || ''
              : WOMEN_SHOE_SIZE_OPTIONS.find((x) => x.id === apparelFormObj.apparelSizeId)?.value || '';

          if (existingApparelValue) {
            apparelDetails.push({
              ...existingApparelValue,
              apparelSize: apparelSizeValue,
              genderType: apparelGenderValue
            })
          } else {
            apparelDetails.push({
              personId,
              nationalTeamApparelId: apparelFormObj.id,
              apparelSize: apparelSizeValue,
              genderType: apparelGenderValue,
              nationalTeamApparel: undefined
            });
          }
        } else {
          errorMessage = 'Please select a size for all apparel items.';
          break;
        }
      }

      if (errorMessage) {
        setErrorState(errorMessage);
      } else {
        setErrorState('');
        onSubmitFormCallback(apparelDetails);
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
  };

  const onCancelClicked = (event) => {
    try {
      event?.preventDefault();

      const newFormGridState = JSON.parse(JSON.stringify(initialFormGridState));

      setFormGridState(newFormGridState);
      setIsDirtyState(false);
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
  };

  const onUpdateApparelGender = (id, newValue) => {
    try {
      const newFormGridState = [...formGridState];

      for (let i = 0; i < newFormGridState.length; i++) {
        if (newFormGridState[i].id === id) {
          if (newFormGridState[i].name.includes(APPAREL_TYPE_NAME_SHOE)) {
            const apparelGenderOption = APPAREL_GENDER_OPTIONS.find((x) => x.id === newValue) || APPAREL_GENDER_OPTIONS[0];
            const apparelSizeOption = apparelGenderOption.value === APPAREL_GENDER_VALUE_MEN
              ? MEN_SHOE_SIZE_OPTIONS[0]
              : WOMEN_SHOE_SIZE_OPTIONS[0];

            newFormGridState[i].apparelGenderId = apparelGenderOption.id;
            newFormGridState[i].apparelSizeId = apparelSizeOption.id;
            newFormGridState[i].hasValue = apparelSizeOption.id > 0;
            newFormGridState[i].isDirty = getIsItemDirty(newFormGridState[i], initialFormGridState[i]);

            break;
          } else {
            const apparelGenderOption = APPAREL_GENDER_OPTIONS.find((x) => x.id === newValue) || APPAREL_GENDER_OPTIONS[0];

            newFormGridState[i].apparelGenderId = apparelGenderOption.id;
            newFormGridState[i].isDirty = getIsItemDirty(newFormGridState[i], initialFormGridState[i]);

            break;
          }
        }
      }

      setFormGridState(newFormGridState);
      setIsDirtyState(getIsDirty(newFormGridState));
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
  };

  const onUpdateApparelSize = (id, newValue) => {
    try {
      const newFormGridState = [...formGridState];

      for (let i = 0; i < newFormGridState.length; i++) {
        if (id === -1 && newFormGridState[i].name.includes(APPAREL_TYPE_NAME_SHOE) === false) {
          const apparelSizeOption = APPAREL_SIZE_OPTIONS.find((x) => x.id === newValue) || APPAREL_SIZE_OPTIONS[0];

          newFormGridState[i].apparelSizeId = apparelSizeOption.id;
          newFormGridState[i].hasValue = apparelSizeOption.id > 0;
          newFormGridState[i].isDirty = getIsItemDirty(newFormGridState[i], initialFormGridState[i]);
        } else if (newFormGridState[i].id === id) {
          if (newFormGridState[i].name.includes(APPAREL_TYPE_NAME_SHOE)) {
            const apparelGenderOption = APPAREL_GENDER_OPTIONS.find((x) => x.id === newFormGridState[i].apparelGenderId);
            const apparelSizeOption = apparelGenderOption.value === APPAREL_GENDER_VALUE_MEN
              ? MEN_SHOE_SIZE_OPTIONS.find((x) => x.id === newValue) || MEN_SHOE_SIZE_OPTIONS[0]
              : WOMEN_SHOE_SIZE_OPTIONS.find((x) => x.id === newValue) || WOMEN_SHOE_SIZE_OPTIONS[0];

            newFormGridState[i].apparelSizeId = apparelSizeOption.id;
            newFormGridState[i].hasValue = apparelSizeOption.id > 0;
            newFormGridState[i].isDirty = getIsItemDirty(newFormGridState[i], initialFormGridState[i]);

            break;
          } else {
            const apparelSizeOption = APPAREL_SIZE_OPTIONS.find((x) => x.id === newValue) || APPAREL_SIZE_OPTIONS[0];

            newFormGridState[i].apparelSizeId = apparelSizeOption.id;
            newFormGridState[i].hasValue = apparelSizeOption.id > 0;
            newFormGridState[i].isDirty = getIsItemDirty(newFormGridState[i], initialFormGridState[i]);

            break;
          }
        }
      }

      setFormGridState(newFormGridState);
      setIsDirtyState(getIsDirty(newFormGridState));
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
  };

  useEffect(() => {
    try {
      if (Array.isArray(gridData) && apparelTypeState.areOptionsLoaded === true) {
        const newFormGridState = createFormGridState(gridData);
        const newInitialFormGridState = JSON.parse(JSON.stringify(newFormGridState));

        setFormGridState(newFormGridState);
        setInitialFormGridState(newInitialFormGridState);
        setIsDirtyState(false);
      } else if (apparelTypeState.areOptionsLoaded === false) {
        getApparelTypes();
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridData, apparelTypeState.areOptionsLoaded]);

  useEffect(() => {
    try {
      if (onIsDirtyChanged) {
        onIsDirtyChanged(isDirtyState);
      }
    } catch (e) {
      onErrorCaught ? onErrorCaught(e) : console.log(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirtyState]);

  function createFormGridState(gridData) {
    const newFormGridState = [];

    for (const apparelTypeOption of apparelTypeState.options) {
      if (apparelTypeOption.id > 0) {
        const existingApparelValue = gridData.find((x) => x.nationalTeamApparelId === apparelTypeOption.id);

        newFormGridState.push(createApparelFormObj(apparelTypeOption, existingApparelValue, competitionGenderTypeCode));
      }
    }

    return newFormGridState;
  }

  function createApparelFormObj(apparelTypeOption, existingApparelValue, defaultGenderCode) {
    const apparelGenderOption = apparelTypeOption.hasGenderType === true
      ? APPAREL_GENDER_OPTIONS.find((x) => x.value === existingApparelValue?.genderType) || APPAREL_GENDER_OPTIONS.find((x) => x.value === defaultGenderCode) || APPAREL_GENDER_OPTIONS[0]
      : APPAREL_GENDER_OPTIONS.find((x) => x.displayInDropdown === false);
    const apparelSizeOption = apparelTypeOption.name.includes(APPAREL_TYPE_NAME_SHOE) === false
      ? APPAREL_SIZE_OPTIONS.find((x) => x.value === existingApparelValue?.apparelSize) || APPAREL_SIZE_OPTIONS[0]
      : apparelGenderOption.value === APPAREL_GENDER_VALUE_MEN
        ? MEN_SHOE_SIZE_OPTIONS.find((x) => x.value === existingApparelValue?.apparelSize) || MEN_SHOE_SIZE_OPTIONS[0]
        : WOMEN_SHOE_SIZE_OPTIONS.find((x) => x.value === existingApparelValue?.apparelSize) || WOMEN_SHOE_SIZE_OPTIONS[0];

    return {
      id: apparelTypeOption.id,
      name: apparelTypeOption.name,
      apparelGenderId: apparelGenderOption.id,
      apparelSizeId: apparelSizeOption.id,
      hasGenderType: apparelTypeOption.hasGenderType,
      hasValue: apparelSizeOption.id > 0,
      isDirty: false
    };
  }

  function getIsDirty(newFormGridState) {
    for (const apparel of newFormGridState) {
      if (apparel.isDirty === true) {
        return true;
      }
    }

    return false;
  }

  function getIsItemDirty(newItem, initialItem) {
    return newItem.apparelGenderId !== initialItem.apparelGenderId || newItem.apparelSizeId !== initialItem.apparelSizeId;
  }

  return {
    isLoading: apparelTypeState.areOptionsLoaded === false,
    isDirty: isDirtyState,
    formGridState,
    errorState,
    onUpdateApparelGender,
    onUpdateApparelSize,
    onSubmitFormGrid,
    onCancelClicked
  };
};

export default useApparelFormGrid;